module.exports = __webpack_public_path__ + "img/113.2d54f739.jpg";